import Picture from '../picture'

interface Props {
  image: string
  heading: string
  desc: string
}

const SolutionBlock = ({ image, heading, desc }: Props) => {
  return (
    <div
      data-aos="fade-left"
      data-aos-duration="700"
      className="bg-white p-6 rounded-2xl"
    >
      <div className="w-16 h-16 bg-primary-10 shrink-0 flex justify-center items-center rounded-lg">
        <Picture
          image={image}
          imageAlt={heading}
          imageStyle="aspect-square w-11 h-11"
        />
      </div>

      <h5 className="mt-4 sm:mt-6 text-neutral-90 text-lg lg:text-xl font-semibold lg:leading-[28px]">
        {heading}
      </h5>
      <p className="mt-1 sm:mt-2 text-neutral-80 leading-[28px] sm:leading-[26px] lg:leading-[28px]">
        {desc}
      </p>
    </div>
  )
}

export default SolutionBlock
